// Copyright (c) 2016 Deere & Company

import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import t from 'tcomb';

const Warranties = t.list(Warranty, 'Warranties');

export const getDefaultState = () => new Warranties([]);

export default Warranties;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state/warranties.js